import { AgrEnvironment, AgrProcessEnv, setAgrEnvironment } from '@next/core-lib/environment';

export type Environment = AgrEnvironment;

export const setEnvironment = ({
  /* APP_SPECIFIC_ENV, */
  ...env
}: AgrProcessEnv): Environment =>
  ({
    /* APP_SPECIFIC_ENV, */
    /* APP_SPECIFIC_ENV: ..., */
    ...setAgrEnvironment(env),
  }) as Environment;
